import React from 'react';
import { withTranslation } from 'react-i18next';

import { Link } from 'formlabs-web-components/Link';
import { DisplayComponent } from 'formlabs-web-components/BaseComponents';
import { Button } from 'formlabs-web-components/Link';
import classNames from 'classnames';

import './Press.module.css';

const PressCoveragesList = DisplayComponent(
  ({ classes, styleNames, styles, posts, t, page, hasNext, hasPrev }) => {
    const prev = parseInt(page, 10) - 1;
    const next = parseInt(page, 10) + 1;

    const listItems = posts.map(post => (
      <li>
        <Link key={post.id} to={post.external_url}>
          <span styleName="date">{post.date}</span>
          <span styleName="outlet-name">{post.outlet_name}</span>
          {post.headline}
          <i class="fl-arrow-right" />
        </Link>
      </li>
    ));
    return (
      <div
        className={classes}
        styleName={classNames(styleNames)}
        style={styles}
      >
        <ul styleName="press_list">{listItems}</ul>
        <div styleName="pagination-wrapper">
          {hasPrev && (
            <Button
              color="light"
              rel="prev"
              url={prev > 0 ? `?page=${prev}` : null}
            >
              <i className="fl-arrow-left" /> {t('Previous')}
            </Button>
          )}
          {hasNext && (
            <Button color="light" rel="next" url={`?page=${next}`}>
              {t('Next')} <i className="fl-arrow-right" />
            </Button>
          )}
        </div>
      </div>
    );
  }
);

export default withTranslation()(PressCoveragesList);
